import { Box } from "../types"

export const boxesList: {
    [key: string]: Box
} = {
    // level 1
    '5': Box.level1,
    '15': Box.level1,
    // level 2
    '60': Box.level2,
    '75': Box.level2,
    '90': Box.level2,
    // level 3
    '150': Box.level3,
    '165': Box.level3,
    '180': Box.level3,
    // level 4
    '200': Box.level4,
    '215': Box.level4,
    '230': Box.level4,
    // level 5
    '270': Box.level4,
    '280': Box.level4,
    '290': Box.level4,
    '295': Box.level5,
    '300': Box.level5,
    // level6
    '335': Box.level5,
    '350': Box.level5,
    '365': Box.level6,
    // level7
    '415': Box.level6,
    '416': Box.level6,
    '417': Box.level7,
    '418': Box.level7, 
    '419': Box.level7,
    // level8
    '479': Box.level8,
    '480': Box.level8,
    '481': Box.level8,
    '482': Box.level8,
    '483': Box.level8,
    '484': Box.level8,
    '485': Box.level8,
    '486': Box.level8,
    '487': Box.level8,
    '488': Box.level8,
    // level9
    '530': Box.level9,
    '550': Box.level9,
    '610': Box.level9,
}